import { useMarkerNoteByline } from "./useMarkerNoteByline";
import type { MarkerNoteBylineProps } from "./types";

export const MarkerNoteByline = ({ note }: MarkerNoteBylineProps) => {
  const { author, timeLabel } = useMarkerNoteByline({ note });

  return (
    <>
      {/* min-w-0 lets an email with no spaces wrap inside the frame instead of pushing it wider. */}
      <span className="min-w-0 break-words font-semibold">{author}</span>
      <span className="whitespace-nowrap opacity-75">· {timeLabel}</span>
    </>
  );
};
